import { trpc } from "../../trpc";
import { Merchant } from "../../types";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Spinner } from "@/components/ui/spinner";
import { toast } from "sonner";

type Props = {
  merchant: Merchant | null;
};

const PipelineConfigTab = ({ merchant }: Props) => {
  const merchantId = merchant?.id ?? "";

  const utils = trpc.useUtils();
  const { data, isLoading } = trpc.pipeline.getDefaultPipelineConfig.useQuery(
    { merchantId },
    { enabled: !!merchantId }
  );

  const mutation = trpc.pipeline.setDisableAppointmentIntentTransfer.useMutation({
    onSuccess: () => {
      toast.success("Configuración de pipeline actualizada");
      utils.pipeline.getDefaultPipelineConfig.invalidate({ merchantId });
    },
    onError: (error) =>
      toast.error("Error al actualizar el pipeline", { description: error.message }),
  });

  if (!merchant) return null;

  if (isLoading || !data) {
    return (
      <div className="flex justify-center py-8">
        <Spinner className="w-6 h-6" />
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between gap-4">
        <div className="space-y-1">
          <Label htmlFor="disableAppointmentIntentTransfer">
            Deshabilitar intención de cita en inactivación
          </Label>
          <p className="text-sm text-muted-foreground">
            Cuando está activo, los leads evaluados por inactividad se marcan como inactivos en
            lugar de transferirse a un asesor como "Intención de cita". El comportamiento normal
            (transferir) es el valor por defecto.
          </p>
        </div>
        <Switch
          id="disableAppointmentIntentTransfer"
          disabled={mutation.isLoading}
          checked={data.disableAppointmentIntentTransfer}
          onCheckedChange={(checked) =>
            mutation.mutate({ merchantId, disabled: checked })
          }
        />
      </div>
    </div>
  );
};

export default PipelineConfigTab;
